import { PieChart } from "@mui/x-charts";

export default function SimplePieChart({ series = [] }) {
  const formatSeries = (series: any[]) => {
    if (!series.length) return [];
    const result = series.map((s, sIndex) => {
      return {
        id: sIndex,
        value: s.data.reduce((acc: number, item: number) => {
          return acc + item;
        }, 0),
        label: s.label,
      };
    });

    return [{ data: result }];
  };

  return <PieChart series={formatSeries(series)}></PieChart>;
}
